/** Politique de rétention des sauvegardes locales. */
export class BackupRetentionPolicy {
  static readonly STORAGE_KEY = 'nexxus.lastBackup';
  /** Alerte si aucune sauvegarde depuis N jours. */
  static readonly STALE_AFTER_DAYS = 30;

  static recordExport(iso = new Date().toISOString()): void {
    localStorage.setItem(this.STORAGE_KEY, iso);
  }

  static getLastExport(): string | null {
    return localStorage.getItem(this.STORAGE_KEY);
  }

  static daysSinceLastExport(): number | null {
    const last = this.getLastExport();
    if (!last) return null;
    return (Date.now() - new Date(last).getTime()) / 86_400_000;
  }

  static isStale(): boolean {
    const days = this.daysSinceLastExport();
    if (days === null) return true;
    return days > this.STALE_AFTER_DAYS;
  }
}
